module.exports = __webpack_public_path__ + "img/background-bottom-image.a164bb6f.svg";